"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/store/auth";
import { useLikesStore } from "@/store/likes";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  useEffect(() => {
    useLikesStore.getState().hydrate(!!user);
  }, [user]);

  return <>{children}</>;
}
